import { CommitmentsPeriodsService_lifePeriodsVersionServiceGetEmploymentPeriods } from '@festina/life-general-types/life/hooks/CommitmentsPeriodsService_lifePeriodsVersionServiceGetEmploymentPeriods'

export const useFetchEmploymentPeriods =
  CommitmentsPeriodsService_lifePeriodsVersionServiceGetEmploymentPeriods.useSuspenseQuery
